import { Methods, Urls } from "../../../common/Utils/ApiConstants";

import { CreateApi } from "../../CreateApi";
const staffHRmanagercollection = CreateApi.injectEndpoints({
  endpoints: (builder) => ({
    getStaffHRManagerListing: builder.mutation({
      query: ({ requestBody, pageNo }) => {
        return {
          url: Urls.hrmanagerList,
          method: Methods.post,
          body: requestBody,
          params: { pageNo },
        };
      },
    }),
    addStaffHRManager: builder.mutation({
      query: (body) => {
        return {
          url: Urls.addHRManager,
          method: Methods.post,
          body: body,
        };
      },
    }),
    viewStaffHRManagerData: builder.mutation({
      query: (body) => {
        return {
          url: `${Urls.viewHRManager}${body}`,
          method: Methods.get,
        };
      },
    }),
    editStaffHRManagerData: builder.mutation({
      query: (body) => {
        return {
          url: `${Urls.editHRManager}${body.managerId}`,
          method: Methods.put,
          body: body.body,
        };
      },
    }),
    rateStaffHRManager: builder.mutation({
      query: (body) => {
        return {
          url: `${Urls.rateHRManager}${body.id}`,
          method: Methods.put,
          body: body.body,
        };
      },
    }),
  }),
});
export const {
  useGetStaffHRManagerListingMutation,
  useAddStaffHRManagerMutation,
  useViewStaffHRManagerDataMutation,
  useRateStaffHRManagerMutation,
  useEditStaffHRManagerDataMutation,
} = staffHRmanagercollection;
